import { render, staticRenderFns } from "./config-table.vue?vue&type=template&id=6b76c020&scoped=true"
import script from "./config-table.vue?vue&type=script&setup=true&lang=js"
export * from "./config-table.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76c020",
  null
  
)

export default component.exports